export default __webpack_public_path__ + "static/media/pg-22.aeea1946.jpg";